module.exports = __webpack_public_path__ + "static/media/IMG_8016.bbfc7511.JPG";